import { visibilityActions } from '../actions';

export default function visibility ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case visibilityActions.SET_VISIBILITY: return generalVisibilityReducer( newState, action );
        case visibilityActions.GENERAL_VISIBILITY_SUCCESS: return generalVisibilityReducer( newState, action );
        default: return newState;
    }
}

function generalVisibilityReducer ( newState, action ) {
    delete action.type;
    return Object.assign( newState, { ...action } );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/visibility.js